import { pencilIcon, trashCanIcon } from "@repo/skapa";
import { Button } from "@repo/skapa";
import { t } from "@repo/translation";
import { ButtonsContainer } from "@repo/ui";

import {
  type AppointmentModalState,
  type AppointmentModalStateActions,
} from "./AppointmentModalReducer";

export const AppointmentEditButtons = ({
  state,
  onEdit,
  onDelete,
  isLoadingDetails,
}: {
  state: AppointmentModalState;
  actions: AppointmentModalStateActions;
  onEdit: () => void;
  onDelete: () => void;
  isLoadingDetails?: boolean;
}) => {
  if (state?.appointment?.type !== "DROP_IN") {
    return null;
  }

  const status = state.appointment?.appointmentStatus;

  const shouldDisable =
    !state?.appointment?.id ||
    status === "COMPLETED" ||
    status === "STARTED" ||
    status === "CANCELLED" ||
    status === "CANCELLED_NO_SHOW";
  return (
    <ButtonsContainer>
      <Button
        size="small"
        iconOnly
        ssrIcon={pencilIcon}
        title={t("action.edit")}
        onClick={onEdit}
        disabled={shouldDisable || isLoadingDetails}
        loading={state.loading === "UPDATING" || isLoadingDetails}
      />
      <Button
        size="small"
        iconOnly
        ssrIcon={trashCanIcon}
        title={t("action.delete")}
        onClick={onDelete}
        disabled={shouldDisable}
        loading={state.loading === "DELETING"}
      />
    </ButtonsContainer>
  );
};
